/**
 * 支付管理 套餐管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>套餐管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="套餐类型:">
        <el-select size="small" v-model="formInline.vid" placeholder="请选择">
          <el-option
            v-for="item in setMeal"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item>
        <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleEdit()"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" prop="id" label="ID" width="200">
      </el-table-column>
      <el-table-column align="center" prop="title" label="描述" width="200">
      </el-table-column>
      <el-table-column align="center" prop="monthNum" label="天数" width="200">
      </el-table-column>
      <el-table-column
        align="center"
        prop="priceSource"
        label="原价"
        width="200"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="priceDiscount"
        label="折扣价"
        width="200"
      >
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.type == 'vip'">会员</div>
          <div v-else-if="scope.row.type == 'day'">day</div>
          <div v-else-if="scope.row.type == 'month'">month</div>
          <div v-else-if="scope.row.type == 'year'">year</div>
          <div v-else-if="scope.row.type == 'hour'">hour</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="px" label="排序号" width="150">
      </el-table-column>
      <el-table-column
        align="center"
        prop="timeFlag"
        label="现时活动"
        width="200"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.timeFlag == "1" ? "现时活动" : "默认" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="操作"
        fixed="right"
        min-width="270"
      >
        <template slot-scope="scope">
          <el-button size="mini" @click="keyUser(scope.$index, scope.row)"
            >查看明细</el-button
          >
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="deleteUser(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-if="editFormVisible"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="套餐类型" prop="vid" v-if="title == '添加'">
          <el-select size="small" class="userRole" v-model="editForm.vid" placeholder="请选择">
            <el-option
            
              v-for="item in setMeal"
              :label="item.name"
              :value="item.id"
              :key="item.id"
              class="userRole"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="天数" prop="monthNum">
          <el-input
            size="small"
            :disabled="title == '查看'"
            v-model="editForm.monthNum"
            auto-complete="off"
            placeholder="请输入天数"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="支付方式" prop="payType">
          <el-select size="small" v-model="editForm.payType" placeholder="请选择" class="userRole">
            <el-option v-for="type in payType" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="原价" prop="priceSource">
          <el-input
            size="small"
            :disabled="title == '查看'"
            v-model="editForm.priceSource"
            auto-complete="off"
            placeholder="请输入原价"
          ></el-input>
        </el-form-item>
        <el-form-item label="折扣价" prop="priceDiscount">
          <el-input
            size="small"
            :disabled="title == '查看'"
            v-model="editForm.priceDiscount"
            auto-complete="off"
            placeholder="请输入折扣价"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="title">
          <el-input
            size="small"
            :disabled="title == '查看'"
            v-model="editForm.title"
            auto-complete="off"
            placeholder="请输入描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select
            size="small"
            :disabled="title == '查看'"
            v-model="editForm.type"
            placeholder="请选择"
            class="userRole"
          >
            <el-option label="day" value="day"></el-option>
            <el-option label="month" value="month"></el-option>
            <el-option label="year" value="year"></el-option>
            <el-option label="hour" value="hour"></el-option>
            <el-option label="会员" value="vip"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序号" prop="px">
          <el-input
            size="small"
            :disabled="title == '查看'"
            v-model="editForm.px"
            auto-complete="off"
            placeholder="请输入排序号"
          ></el-input>
        </el-form-item>
        <el-form-item label="限时活动" prop="type">
          <el-select
            size="small"
            :disabled="title == '查看'"
            v-model="editForm.timeFlag"
            placeholder="请选择"
            class="userRole"
          >
            <el-option label="默认" :value="0"></el-option>
            <el-option label="限时活动" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div v-if="title != '查看'">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
            size="small"
            type="primary"
            :loading="loading"
            class="title"
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
        <div v-else>
          <el-button size="small" @click="closeDialog">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  vpnVipPage,
  vpnVipAdd,
  vpnVipUpdate,
  vpnVipGet,
  vpnVipDelete,
  vipTypeList,
} from "../../api/payMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      payType: [
        { key: "现金", value: 1 },
        { key: "支付宝", value: 2 },
        { key: "微信", value: 3 },
        { key: "POS通", value: 4 },
        { key: "闪付", value: 5 },
        { key: "POS通C扫B", value: 6 },
        { key: "银联二维码", value: 8 },
        { key: "会员余额支付", value: 9 },
      ],
      editForm: {
        monthNum: "",
        priceSource: "",
        priceDiscount: "",
        title: "",
        type: "",
        timeFlag: "",
        px: "",
        vid: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {
        monthNum: [{ required: true, message: "请输入天数", trigger: "blur" }],
        priceSource: [
          { required: true, message: "请输入原价", trigger: "blur" },
        ],
        priceDiscount: [
          { required: true, message: "请输入折扣价", trigger: "blur" },
        ],
        vid: [{ required: true, message: "套餐类型不能为空", trigger: "blur" }],
        title: [{ required: true, message: "请输入描述", trigger: "blur" }],
        px: [{ required: true, message: "请输入排序号", trigger: "blur" }],
        type: [{ required: true, message: "请选择状态", trigger: "blur" }],
        timeFlag: [{ required: true, message: "请选择状态", trigger: "blur" }],
        payOpen: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },
      formInline: {
        pageNo: 0,
        pageSize: 999,
        varLable: "",
        varName: "",
        vid: "",
        token: localStorage.getItem("logintoken"),
      },
      setMeal: [],
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true;

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      vpnVipPage(parameter)
        .then((res) => {
          this.loading = false;
          if (res.data.success == false) {
            this.$message({
              type: "info",
              message: res.data.msg,
            });
          } else {
            this.listData = res.data.dataList;
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.page
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });

      vipTypeList().then((res) => {
        if (res.code == 0) {
          this.setMeal = res.data;
          console.log("套餐类型", this.setMeal);
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.pageNo = 0;
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.id = row.id;
        this.editForm.monthNum = row.monthNum;
        this.editForm.priceSource = row.priceSource;
        this.editForm.priceDiscount = row.priceDiscount;
        this.editForm.title = row.title;
        this.editForm.type = row.type;
        this.editForm.px = row.px;
        this.editForm.timeFlag = row.timeFlag;
      } else {
        this.title = "添加";
        this.editForm.id = null;
        this.editForm.monthNum = "";
        this.editForm.priceSource = "";
        this.editForm.priceDiscount = "";
        this.editForm.title = "";
        this.editForm.type = "";
        this.editForm.px = "";
        this.editForm.timeFlag = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          if (this.title == "添加") {
            vpnVipAdd(this.editForm)
              .then((res) => {
                this.editFormVisible = false;
                this.loading = false;
                if (res.success) {
                  this.getdata(this.formInline);
                  this.$message({
                    type: "success",
                    message: "保存成功！",
                  });
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error("套餐管理保存失败，请稍后再试！");
              });
          } else {
            vpnVipUpdate(this.editForm)
              .then((res) => {
                this.editFormVisible = false;
                this.loading = false;
                if (res.success) {
                  this.getdata(this.formInline);
                  this.$message({
                    type: "success",
                    message: "保存成功！",
                  });
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error("套餐管理保存失败，请稍后再试！");
              });
          }
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          vpnVipDelete({ id: row.id })
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "套餐已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("套餐管理删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    keyUser(index, rowItem) {
      vpnVipGet({ id: rowItem.id }).then((res) => {
        this.loading = false;
        if (res.data.success == false) {
          this.$message({
            type: "info",
            message: "res.data.msg",
          });
        } else {
          this.editFormVisible = true;
          let row = res.data;
          if (row != undefined && row != "undefined") {
            this.title = "查看";
            this.editForm.id = row.id;
            this.editForm.monthNum = row.monthNum;
            this.editForm.priceSource = row.priceSource;
            this.editForm.priceDiscount = row.priceDiscount;
            this.editForm.title = row.title;
            this.editForm.type = row.type;
            this.editForm.px = row.px;
            this.editForm.timeFlag = row.timeFlag;
          }
        }
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/machine/MachineConfigPhone.vue